/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {
  LHP_ACTION_PANEL_WIDTH,
  LHP_ACTION_PANEL_BORDER,
  THUMBNAILS_FEATURE_WIDTH,
  BOOKMARKS_FEATURE_WIDTH,
  ATTACHMENTS_FEATURE_WIDTH
} from "constants/constants";
import { isCurrentDeviceMobile } from "dc-preview-utils/src/Utils/DeviceUtils";
import { lhpFeatures } from "constants/enums";
import { getViewMode } from "selectors/viewModeSelectors";
import { docViewModes } from "constants/enums";

export const currLHPFeature = stores => stores.lhpStore.currLHPFeature;
export const showUndoButton = stores => stores.lhpStore.showUndoButton;
export const showRedoButton = stores => stores.lhpStore.showRedoButton;
export const getLHPVisibility = stores => !isCurrentDeviceMobile() && stores.lhpStore.showLHP;

export const getLHPFeatureWidth = stores => {
  let lhpFeatureWidth = 0;
  switch (currLHPFeature(stores)) {
    case lhpFeatures.THUMBNAIL:
      lhpFeatureWidth = THUMBNAILS_FEATURE_WIDTH;
      break;
    case lhpFeatures.BOOKMARKS:
      lhpFeatureWidth = BOOKMARKS_FEATURE_WIDTH;
      break;
    case lhpFeatures.ATTACHMENTS:
      lhpFeatureWidth = ATTACHMENTS_FEATURE_WIDTH;
      break;
  }
  return lhpFeatureWidth;
};
